import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

import TopStrip from '../components/TopStrip';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HelpButton from '../components/HelpButton';
import TestimonialsCarousel from '../components/TestimonialsCarousel';

// Images
import heroBanner from '../assets/images/hero-images/company.webp';
import heroMobile from '../assets/images/mobile-banners/About-company-mobile.webp';
import personImg from '../assets/images/company-page/image-removebg-preview.png';
import missionImg from '../assets/images/company-page/mission.png';
import methodImg from '../assets/images/company-page/method.png';
import downloadSectionImg from '../assets/images/webp-images/download-section-img.webp';
import companyBg from '../assets/images/webp-images/company-section-bg.webp';

import sla from '../assets/images/company-page/standard-slider-icons/SLA-Backed Reliability.jfif';
import fullCycle from '../assets/images/company-page/standard-slider-icons/Full-Cycle Product Engineering.jpg';
import qualityGates from '../assets/images/company-page/standard-slider-icons/Automated Quality Gates.jpg';
import cloudModernization from '../assets/images/company-page/standard-slider-icons/Cloud Modernization Strategy.jfif';
import academyCertified from '../assets/images/company-page/standard-slider-icons/Academy-Certified Engineers.jfif';
import zeroTrust from '../assets/images/company-page/standard-slider-icons/Zero-Trust Security.jfif';

import portfolio1 from '../assets/images/portfolio/1.webp';
import portfolio2 from '../assets/images/portfolio/2.webp';
import portfolio3 from '../assets/images/portfolio/3.webp';
import imtiaz from '../assets/images/portfolio/imtiaz.png';
import burque from '../assets/images/portfolio/burque.png';
import foree from '../assets/images/portfolio/foree.png';
import mysurefit from '../assets/images/portfolio/mySureFit.png';
import uhf from '../assets/images/portfolio/uhfSolution.png';
import humenai from '../assets/images/portfolio/9.png';
import avianet from '../assets/images/portfolio/10.png';
import sindhEdu from '../assets/images/portfolio/sindhEducational.png';
import digiChowk from '../assets/images/portfolio/12.png';
import tplInsurance from '../assets/images/portfolio/tplInsurrance.png';
import everyWater from '../assets/images/portfolio/everyWater.png';

import companyPdf from '../assets/pdfs/DDevOps-Company-Profile.pdf';

// Text changing effect
const changingWords = ['Operations', 'Infrastructure', 'Security', 'Development', 'Pipelines'];

const portfolioCards = [
  { img: portfolio1,   name: 'House Of Chenille',  url: 'https://houseofchenille.com/' },
  { img: portfolio2,   name: 'Designs Intellect',  url: 'https://designsintellect.com.au/' },
  { img: portfolio3,   name: 'Hoojan',             url: 'https://www.hoojan.com' },
  { img: imtiaz,       name: 'Imtiaz Super Market',url: 'https://imtiaz.com.pk/' },
  { img: burque,       name: 'Burque',             url: 'https://www.burque.com.pk/' },
  { img: foree,        name: 'Foree',              url: 'https://foree.co/consumer' },
  { img: mysurefit,    name: 'Mysurefit',          url: 'https://mysurefit.co/' },
  { img: uhf,          name: 'UHF Solutions',      url: 'https://uhfsolutions.com/' },
  { img: humenai,      name: 'Humenai',            url: 'https://humenai.com/' },
  { img: avianet,      name: 'Avianet',            url: 'https://www.avianet.aero/' },
  { img: sindhEdu,     name: 'Sindh Education',    url: 'https://www.sindheducation.gov.pk/' },
  { img: digiChowk,    name: 'Digi Chowk',         url: 'https://digichowk.com/' },
  { img: tplInsurance, name: 'TPL Insurance',      url: 'https://digichowk.com/' },
  { img: everyWater,   name: 'Every Water',        url: 'https://digichowk.com/' },
];

const services = [
  { title: 'Managed Shared Hosting', desc: 'Perfect for starting out. Secure, high-performance shared environments fully managed by our support team, so you don\'t worry about server maintenance.' },
  { title: 'Cloud Infrastructure Management', desc: 'We manage your instances on AWS, Azure, or our private cloud. You get the scalability of the cloud with the hands-on support of DDevOps.' },
  { title: 'Dedicated Server Solutions', desc: 'Raw power for enterprise workloads. Get bare-metal performance with a dedicated team monitoring your hardware and OS 24/7.' },
  { title: 'CI/CD Pipeline Architecture', desc: 'We automate your delivery. From code commit to production, we build pipelines that test and deploy your software instantly and safely.' },
  { title: 'DevSecOps & Hardening', desc: 'Enhancing the strength of firewalls is just the start. We implement automated security scans and compliance protocols to protect data from malicious sources.' },
  { title: 'Backend Engineering', desc: 'Our development specialists don\'t just write code; they architect scalable backends designed to run efficiently on your specific infrastructure.' },
];

function AboutCompany() {
  const wordRef = useRef(null);
  const wordIndex = useRef(0);

  useEffect(() => {
    const interval = setInterval(() => {
      wordIndex.current = (wordIndex.current + 1) % changingWords.length;
      if (wordRef.current) wordRef.current.textContent = changingWords[wordIndex.current];
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <TopStrip />
      <Navbar />

      {/* Hero */}
      <section style={{ marginTop: '125px' }}>
        <div className="container-fluid p-0">
          <img src={heroBanner} width="1600" height="520" alt="Engineering the future" className="img-fluid w-100 d-none d-md-block" />
          <img src={heroMobile} width="768" height="1000" alt="Engineering the future" className="img-fluid w-100 d-md-none d-block" />
        </div>
      </section>

      {/* Changing Word Heading */}
      <div className="container txt-changing text-center top-line" style={{ marginTop: '5rem' }}>
        <h2 data-aos="fade-up" className="fw-semibold" style={{ fontSize: '2.4rem' }}>
          End-to-End Engineering For Your <br />
          <span className="txt-color" ref={wordRef}>Operations</span>
        </h2>
      </div>

      {/* 10 Years Experience */}
      <div className="container py-5 overflow-hidden">
        <div className="row align-items-center gy-4" data-aos="fade-up">
          <div className="col-lg-6">
            <div className="d-flex justify-content-center">
              <div className="d-flex align-items-center text-center">
                <span className="txt-color fw-semibold ten-number me-3">10+</span>
                <div className="fw-bold text-uppercase small opacity-50">
                  YEARS <br /> OF <br /> CLOUD <br /> MASTERY
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 position-relative ps-lg-5">
            <div className="vertical-line d-none d-md-block"></div>
            <h4 className="fw-bold text-center text-lg-start">More Than Just Support. We Are Builders.</h4>
            <p className="fs-6 m-0 text-center text-lg-start">
              From the rise of Docker to the dominance of Kubernetes, DDevOps has been at the forefront of infrastructure evolution. We combine <strong>Dedicated Service</strong> with the educational power of <strong>DDevOps Academy</strong> to deliver an invincible team for your business.
            </p>
          </div>
        </div>
      </div>

      {/* 3 Cards */}
      <section className="py-5 image-box" style={{ marginTop: '4rem', backgroundImage: `url(${companyBg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="container">
          <div className="row gy-4 justify-content-center">
            {[
              { img: personImg, title: 'The People', desc: 'We combine 18+ years of battle-tested IT experience with the fresh, cutting-edge talent produced by DDevOps. We are not just support staff; we are elite engineers who embed ourselves into your culture to drive success from the inside out.' },
              { img: missionImg, title: 'The Mission', desc: 'We shift the focus from \'fixing crashes\' to \'preventing them.\' Our goal is to build self-healing, automated infrastructures that allow your developers to deploy code without fear, turning your operations into a strategic competitive advantage.' },
              { img: methodImg, title: 'The Method', desc: 'We eliminate human error through code. By utilizing Infrastructure as Code (IaC) and rigorous CI/CD pipelines, we ensure your platform is scalable, secure, and cost-efficient—delivering maximum uptime with zero friction.' },
            ].map((card, i) => (
              <div className="col-12 col-sm-8 col-md-6 col-lg-4" key={i}>
                <div className="card h-100 text-center shadow p-4 border-0 rounded-4">
                  <img src={card.img} loading="lazy" alt={card.title} className="img-fluid mb-3 mx-auto d-block" style={{ maxHeight: '120px', objectFit: 'contain' }} />
                  <h5 className="mb-2 fw-bold text-uppercase" style={{ fontSize: '1.1rem' }}>{card.title}</h5>
                  <p className="text-muted small" style={{ textAlign: 'justify' }}>{card.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Download Section */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="text-center mb-5">
            <h4 className="fw-semibold mb-2 top-line">Complex infrastructure is our playground.</h4>
            <p className="text-muted fw-semibold">Ready to scale without the headaches?</p>
            <Link to="/contact" className="fs-5 fw-bold">Take the challenge!</Link>
          </div>
          <div className="row align-items-center gy-4" style={{ marginTop: '5rem' }}>
            <div className="col-lg-6 col-md-12 text-center text-lg-start" data-aos="fade-left">
              <div className="px-3 px-lg-5">
                <h2 className="fw-bold mb-3">
                  <span className="txt-color text-uppercase">Transparency in Engineering</span>
                </h2>
                <p className="fw-semibold text-muted text-uppercase">Download our full technical portfolio, security protocols, and engineering standards.</p>
                <a className="btn btn-info text-white fw-bold px-4 py-3 mt-2 d-inline-block" target="_blank" rel="noreferrer" href={companyPdf}>
                  Download Executive Brief (1.5MB)
                </a>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 text-center" data-aos="fade-right">
              <img src={downloadSectionImg} loading="lazy" alt="Company Profile" className="img-fluid floating-icon mt-4" style={{ maxHeight: '350px', objectFit: 'contain' }} />
            </div>
          </div>
        </div>
      </section>

      {/* Standards Carousel */}
      <section className="py-5 bg-light">
        <div className="container text-center">
          <h2 className="mb-3 fw-semibold">The Standards We Live By.</h2>
          <div className="d-flex justify-content-center gap-3 mb-4">
            <button className="btn btn-outline-info btn-sm px-4" type="button" data-bs-target="#standardsCarousel" data-bs-slide="prev">← Previous</button>
            <button className="btn btn-info btn-sm px-4 text-white" type="button" data-bs-target="#standardsCarousel" data-bs-slide="next">Next →</button>
          </div>
          <div id="standardsCarousel" className="carousel slide" data-bs-ride="carousel" data-bs-interval="3500" data-bs-pause="hover">
            <div className="carousel-inner">
              <div className="carousel-item active">
                <div className="row g-4 justify-content-center">
                  {[{ img: sla, title: 'SLA-Backed Reliability', desc: 'We don\'t just promise uptime — we guarantee performance through transparent, measurable SLAs that protect your business.' },
                    { img: fullCycle, title: 'Full-Cycle Product Engineering', desc: 'From MVP to enterprise scale, we continuously enhance architecture, scalability, and performance.' },
                    { img: qualityGates, title: 'Automated Quality Gates', desc: 'Smart CI/CD pipelines automatically catch bugs, ensuring only production-ready code is deployed.' }
                  ].map((s, i) => (
                    <div className={`col-md-6 col-lg-4 ${i > 0 ? 'd-none d-md-block' : ''} ${i > 1 ? 'd-none d-lg-block' : ''}`} key={i}>
                      <div className="feature-card h-100">
                        <div className="icon-wrap mb-3">
                          <img src={s.img} alt={s.title} width="120" className="feature-icon" />
                        </div>
                        <h5 className="fw-semibold text-info mt-2">{s.title}</h5>
                        <p>{s.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="carousel-item">
                <div className="row g-4 justify-content-center">
                  {[{ img: cloudModernization, title: 'Cloud Modernization Strategy', desc: 'We modernize legacy systems into cloud-native, scalable infrastructures without disruption.' },
                    { img: academyCertified, title: 'Academy-Certified Engineers', desc: 'Our engineers undergo rigorous certification, mastering deep system internals and best practices.' },
                    { img: zeroTrust, title: 'Zero-Trust Security', desc: 'Security-first approach with real-time threat detection, access control, and automated compliance.' }
                  ].map((s, i) => (
                    <div className={`col-md-6 col-lg-4 ${i > 0 ? 'd-none d-md-block' : ''} ${i > 1 ? 'd-none d-lg-block' : ''}`} key={i}>
                      <div className="feature-card h-100">
                        <div className="icon-wrap mb-3">
                          <img src={s.img} alt={s.title} width="120" className="feature-icon" />
                        </div>
                        <h5 className="fw-semibold text-info mt-2">{s.title}</h5>
                        <p>{s.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <TestimonialsCarousel />

      {/* Statistics */}
      <section className="bg-info-subtle py-5">
        <div className="container">
          <div className="row text-center">
            {[
              { num: '1,190', label: 'MANAGED CLIENTS' },
              { num: '91', label: 'DEVOPS TRANSFORMATIONS' },
              { num: '47', label: 'CERTIFIED ENGINEERS' },
            ].map((stat, i) => (
              <div className={`col-md-4 mb-4 mb-md-0 position-relative`} key={i}>
                <h2 className="fw-bold text-info display-5 mb-0">{stat.num}</h2>
                <p className="text-uppercase mt-2 fw-semibold">{stat.label}</p>
                {i < 2 && <div className="d-none d-md-block position-absolute top-0 end-0 h-100" style={{ width: '1px', backgroundColor: 'gray' }}></div>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Managed Services Grid */}
      <section className="py-5 bg-light" style={{ marginTop: '7rem' }}>
        <div className="container text-center">
          <h2 className="mb-5 fw-semibold">Discover our range of tailored Managed IT Services.</h2>
          <div className="row gy-4">
            {services.map((s, i) => (
              <div className="col-md-6 col-lg-4" key={i}>
                <h5 className="text-info fw-bold">{s.title}</h5>
                <p className="small">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Global Reach Heading */}
      <div className="container" style={{ marginTop: '4rem' }}>
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-8">
            <h2 className="text-center top-line text-uppercase text-info fw-bold">Global Reach. 24/7 Stability.</h2>
            <p className="text-center fs-5">
              From <b>North American</b> startups to <b>European</b> enterprises and <b>Pakistan</b> fintechs—join <b>1,000+ businesses worldwide</b> that trust <span className="text-info fw-semibold">DDevOps</span> to keep their infrastructure online, round the clock
            </p>
          </div>
        </div>
      </div>

      {/* Portfolio Slider */}
      <section>
        <div className="container mt-5 px-3 px-md-4">
          <Swiper
            modules={[Autoplay]}
            slidesPerView={1}
            spaceBetween={20}
            loop={true}
            autoplay={{ delay: 1500, disableOnInteraction: false }}
            breakpoints={{ 768: { slidesPerView: 2, spaceBetween: 20 }, 992: { slidesPerView: 3, spaceBetween: 23 } }}
          >
            {portfolioCards.map((card, i) => (
              <SwiperSlide key={i}>
                <a href={card.url} target="_blank" rel="noreferrer" className="text-decoration-none">
                  <div className="card text-center shadow-sm border-0 rounded-4 p-4 h-100">
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '180px' }}>
                      <img src={card.img} loading="lazy" className="img-fluid floating-icon" style={{ maxHeight: '150px', objectFit: 'contain' }} alt={card.name} />
                    </div>
                    <h5 className="mt-3 fw-semibold text-dark">{card.name}</h5>
                  </div>
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      <Footer />
      <HelpButton />
    </>
  );
}

export default AboutCompany;